export const pregnancyEnum = {
  question: "Are you pregnant?",
  options: [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
    {
      label: "Does not apply",
      value: "Does not apply",
    },
  ],
};

export const trimesterEnum = {
  question: " Select trimester",
  options: [
    {
      label: "1st trimester (Conception - 12 weeks)",
      value: "First",
    },
    {
      label: "2nd trimester (12 - 24 weeks)",
      value: "Second",
    },
    {
      label: "3rd trimester (24+ weeks)",
      value: "Third",
    },
  ],
};

export const breastfeedingEnum = {
  question: "Are you breastfeeding?",
  options: [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
    {
      label: "Does not apply",
      value: "Does not apply",
    },
  ],
};
